import "./CSS_styles/heading.css";

export default function ShimmerBackground() {


  return (
    <div className="shimmer-strip">
  <div className="hero-container">

    <div className="shimmer-text">
      <h1><strong>I am Ankith Rudra.</strong></h1>
      <p>

        I build intelligent systems and interactive experiences across AI, backend engineering, distributed systems, and creative interfaces. 
        <br /><br />
        I like making things that are fast, smart, and actually enjoyable to use.
        <br /><br /> Especially passionate about AI/ML, LLMs, and computer vision.

      </p>
    </div>

    <div className="explore-more">
  <div className="explore-line" />
  <div className="explore-copy">
    <p>Projects / Games</p>
    <span>Interactive projects, games.
      <br/> ASMR game in 3D mode.
    </span>

    <p>SWITCH TO 3D</p>
    <span>Move from interface to 3D. <br/> ASMR game in 3D mode.</span>
  </div>
</div>

  </div>
</div>
  );
}